// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import { checkFile } from 'backend/complaint';
import { local } from 'wix-storage';
import wixLocation from 'wix-location';

$w.onReady(function () {
    let complaint = local.getItem('complaint');

    switch(complaint){
        case 'district':
        $w('#state').changeState('DistrictProsecutor');
        break;
        case 'kzd':
        $w('#state').changeState('KZD');
        break;
        case 'mvr':
        $w('#state').changeState('MVR');
        break;
        case 'court':
        $w('#state').changeState('RegionalCourt');
        break;
    }
});

export function download_click(event) {
    const fileName = local.getItem('fileName');
    const filePath = local.getItem('filePath');

    // console.log('fileName: ', fileName);
    // console.log('filePath: ', filePath);

    if (fileName && filePath) {
        checkFile(fileName).then(response => {
            if (response) {
                wixLocation.to(filePath);
            } else {
                local.removeItem('fileName');
                local.removeItem('filePath');
            }
        }).catch(error => {
            local.removeItem('fileName');
            local.removeItem('filePath');
			console.log('error: ', error);
        })
    }
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
